<template>
  <v-card flat
          class="full-height">
    <v-expansion-panels accordion
                        v-model="openPanel">
      <!-- Sendbox unsent items-->
      <v-expansion-panel>
        <v-expansion-panel-header>
          <div>
            <v-badge color="error"
                     :content="`${sendbox.length}`"
                     overlap
                     :offset-x="2"
                     :offset-y="6"
                     left>
              <div>{{ $t('sendbox.sendItems') }}</div>
            </v-badge>
            <div class="caption pt-1"
                 style="line-height: 1">{{ $t('sendbox.itemsToSend') }}</div>
          </div>
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <div class="caption pt-1"
               style="line-height: 1.1"
               v-if="sendbox.length === 0">{{ $t('sendbox.noItemsToSend') }}</div>
          <v-virtual-scroll v-else
                            :items="sendbox"
                            :height="Math.min(lineHeight * 4, sendbox.length * lineHeight)"
                            :item-height="lineHeight">
            <template v-slot:default="{ item }">
              <component :key="item.objectCreated"
                         :is="getVueItemType(item)"
                         :sendboxItem="item"></component>
            </template>
          </v-virtual-scroll>
        </v-expansion-panel-content>
      </v-expansion-panel>

      <!-- Sendbox sent items-->
      <v-expansion-panel>
        <v-expansion-panel-header>
          <div class="headerColor">
            <v-badge color="error"
                     :content="`${sendboxSent.length}`"
                     overlap
                     :offset-x="2"
                     :offset-y="6"
                     left>
              <div>{{ $t('sendbox.sentItems') }}</div>
            </v-badge>
            <div class="caption pt-1"
                 style="line-height: 1.1"
                 v-if="sendboxSent.length === 0">{{ $t('sendbox.noSentItems') }}</div>
            <div class="caption pt-1"
                 style="line-height: 1.1"
                 v-else>{{ sentItemsDetailText }}</div>
            <!-- $t('sendbox.sentItems') -->
          </div>
        </v-expansion-panel-header>
        <v-expansion-panel-content class="sendbox-sent"
                                   style="margin-bottom: 100px">
          <v-virtual-scroll style="overflow-y: auto !important"
                            :items="sendboxSent"
                            :height="Math.min(lineHeight * (xs ? 4 : 10), sendboxSent.length * lineHeight)"
                            :item-height="lineHeight">
            <template v-slot:default="{ item }">
              <component :key="item.objectCreated"
                         :is="getVueItemType(item)"
                         :sendboxItem="item"></component>
            </template>
          </v-virtual-scroll>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
  </v-card>
</template>

<script>
import commonMixin from '@/mixins/common';
import SendboxItem from '@/components/sendbox/SendboxItem.vue';
import SendboxItem2 from '@/components/sendbox/SendboxItem2.vue';

const sendboxTypeToVueItemMapping = {
  documentUserState: 'SendboxItem',
};
export default {
  mixins: [commonMixin],
  components: {
    SendboxItem,
    SendboxItem2,
  },
  data() {
    return {
      lineHeight: 110,
      openPanel: 1,
    };
  },
  computed: {
    maxSentItems() {
      return this.$store.state.configs.features.sentSendboxItemCount;
    },
    sendbox() {
      return this.$store.getters['sendbox/getSendbox']().filter((sendboxItem) => {
        if (sendboxItem.userNotification) {
          return sendboxItem.userNotification.showInSendbox; //sendboxItem2 (to be recognized by subject attribute) types only displayed if showInSendbox is enabled
        }
        return true; // show all old SendboxItem items without showInSendbox feature
      });
    },
    sendboxSent() {
      return this.$store.getters['sendbox/getSendboxSentItems']().filter((sendboxItem) => {
        if (sendboxItem.userNotification) {
          return sendboxItem.userNotification.showInSendbox; //sendboxItem2 (to be recognized by subject attribute) types only displayed if showInSendbox is enabled
        }
        return true; // show all old SendboxItem items without showInSendbox feature
      });
    },
    sentItemsDetailText() {
      return this.$t('sendbox.sentItemsDetails', { maxSendItems: this.maxSentItems });
    },
  },

  methods: {
    getVueItemType(item) {
    // return 'SendboxItem2';
     return item.subject ? 'SendboxItem2' : 'SendboxItem'; //SendboxItem2
    },
  },
};
</script>
<style>
.sendbox-sent > div.v-expansion-panel-content__wrap {
  padding-left: 0 !important;
  padding-right: 0 !important;
}
</style>
